import React from 'react';
import PropTypes from 'prop-types';

import './modal.css';

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.close = this.close.bind(this);
        this.onKey = this.onKey.bind(this);
        this.renderTitle = this.renderTitle.bind(this);
    }

    onKey(event) {
        if (event.key === 'Escape' && !this.props.managedClose) {
            this.close();
        }
    }

    close() {
        this.props.onClose();
    }

    renderTitle() {
        const { title } = this.props;
        if (title) {
            return (
                <div className="row">
                    <span className="col-xs-12 text-center title">{title}</span>
                </div>
            );
        }

        return null;
    }

    render() {
        const { open, managedClose, size, children } = this.props;
        if (!open) {
            return null;
        }

        return (
            <div className="gl-modal" onKeyUp={this.onKey}>
                <style>{`body { overflow: hidden; position: fixed; }`}</style>
                <div className="overlay" />
                <div className="gl-modal-inner" onClick={managedClose ? () => null : this.close}>
                    <div className="container">
                        <div className="row">
                            <div className={size ? size : 'col-xs-12'}>
                                <div className="gl-content" onClick={event => event.stopPropagation()}>
                                    {this.renderTitle()}
                                    <div>{children}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Modal.defaultProps = {
    open: false,
    size: 'col-xs-12',
    title: null,
    children: {},
    managedClose: false
};

Modal.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    size: PropTypes.string,
    title: PropTypes.any,
    children: PropTypes.node,
    managedClose: PropTypes.bool
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/index.jsx